import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import type {
  GetMultiPartnerHealthResponse,
  GetSalesConfigResponse,
  ListPartnerHealthResponse,
  ListTrialResponse,
  PartnerHealth,
  SalesConfigInputs,
  SetSalesConfigResponse,
  Trial,
} from '@vendasta/protos/partner/v1/types';
import type { PartnerHealthState, PartnerHealthSubState } from '@vendasta/protos/partner/v1/enums';

export const PartnerServiceInterfaceToken: InjectionToken<PartnerServiceInterface> =
  new InjectionToken<PartnerServiceInterface>('PartnerServiceInterface');

export interface PartnerServiceInterface {
  getPartnerId(): Observable<string>;
}

export interface PartnerTrialServiceInterface {
  createTrial(partnerId: string, subscriptionId: string, start: Date, end: Date): Observable<boolean>;
  getTrial(partnerId: string): Observable<Trial | undefined>;
  cancelTrial(partnerId: string, trialId: string): Observable<boolean>;
  listTrial(partnerId: string, pageSize: number, cursor: string): Observable<ListTrialResponse>;
}

export interface PartnerHealthsServiceInterface {
  set(
    partnerId: string,
    state: PartnerHealthState,
    subState: PartnerHealthSubState,
    reason: string,
    inRetention: boolean,
  ): Observable<boolean>;
  get(partnerId: string): Observable<PartnerHealth | undefined>;
  list(partnerId: string, pageSize: number, cursor: string): Observable<ListPartnerHealthResponse>;
  getMulti(partnerIds: string[]): Observable<GetMultiPartnerHealthResponse>;
}

export interface PartnerSalesServiceInterface {
  setConfiguration(partnerId: string, marketId: string, config: Partial<SalesConfigInputs>): Observable<SetSalesConfigResponse>;
  getConfiguration(partnerId: string, marketId: string): Observable<GetSalesConfigResponse>;
}
